module.exports = __webpack_public_path__ + "img/JC_Steele_Img.353ebd29.png";